module.exports = __webpack_public_path__ + "img/CM-SS-25-Ford-Modern.d784a5fe.jpg";